import styled from "styled-components"

const TransferManageUpload = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 30px;
  font-size: ${props => props.theme.font.size.menuitem};
  text-align: center;

  & i {
    position: relative;
    left: -2px;
  }
`

export default TransferManageUpload
